import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("apptrack_token");
        if (!token) {
            setLoading(false);
            return;
        }
        axios
            .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setUser(r.data))
            .catch(() => localStorage.removeItem("apptrack_token"))
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await axios.post(`${API}/auth/login`, { email, password });
        localStorage.setItem("apptrack_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const loginWithToken = (token, userData) => {
        localStorage.setItem("apptrack_token", token);
        setUser(userData);
        return userData;
    };

    const logout = async () => {
        try {
            await axios.post(`${API}/auth/logout`);
        } catch {}
        localStorage.removeItem("apptrack_token");
        setUser(null);
    };

    return <AuthContext.Provider value={{ user, loading, login, logout, loginWithToken }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
